import { AjaxLoaderData } from "./AbstractAjaxLoader.js";

export interface Encoder {
    encode(ajax: XMLHttpRequest, data: AjaxLoaderData): Promise<any>;
}

export interface LoaderEncoderMap {
}

type EncoderLookup = {
    [P in keyof LoaderEncoderMap]?: Encoder;
}

export const encoders: EncoderLookup = {};

export function registerEncoder<T extends keyof LoaderEncoderMap>(key: T, encoder: LoaderEncoderMap[T]): void {
    encoders[key] = encoder;
}

/**
 * JSON encoder
 */
// class JsonEncoder implements Encoder {
//     public async encode(ajax: XMLHttpRequest, data: AjaxLoaderData): Promise<any> {
//         // ajax.setRequestHeader("Content-Type", "multipart/form-data");
//         // ajax.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
//         // ajax.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

//         var formData = new FormData();

//         if (typeof data === "string") {
//             formData.append("data", data);
//             return formData;
//         }

//         for (var key in data) {
//             formData.append(key, JSON.stringify(data[key]));
//         }

//         return formData;
//     }
// }

class JsonEncoder implements Encoder {
    public async encode(ajax: XMLHttpRequest, data: AjaxLoaderData): Promise<any> {
        ajax.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");

        var res: string[] = [];
        if (typeof data === "string") {
            res.push(encodeURIComponent("data") + "=" + encodeURIComponent(data));
        } else {
            for (var key in data) {
                res.push(encodeURIComponent(key) + "=" + encodeURIComponent(JSON.stringify(data[key])));
            }
        }
        return res.join("&").replace(/%20/g, '+');
    }
}


export interface LoaderEncoderMap {
    "json": JsonEncoder;
}

registerEncoder("json", new JsonEncoder());

/**
 * JSON raw encoder
 */
class JsonRawEncoder implements Encoder {
    public async encode(ajax: XMLHttpRequest, data: AjaxLoaderData): Promise<any> {
        ajax.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        return JSON.stringify(data);
    }
}

export interface LoaderEncoderMap {
    "jsonraw": JsonRawEncoder;
}

registerEncoder("jsonraw", new JsonRawEncoder());

/**
 * Text encoder
 */
class TextEncoder implements Encoder {
    public async encode(ajax: XMLHttpRequest, data: AjaxLoaderData): Promise<any> {
        ajax.setRequestHeader("Content-Type", "application/text;charset=UTF-8");
        return String(data);
    }
}

export interface LoaderEncoderMap {
    "text": TextEncoder;
}

registerEncoder("text", new TextEncoder());